// material ui
import { LinearProgress } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

const LinearLoadingIndicator = ({ isLoading }) => {
  const theme = useTheme();

  if (!isLoading) return null;

  return (
    <LinearProgress
      sx={{
        mb: -0.5,
        height: 4,
        borderRadius: 999,
        backgroundColor: alpha(theme.palette.brand.main, 0.2),
        '& .MuiLinearProgress-bar': {
          borderRadius: 999,
          backgroundColor: theme.palette.brand.main,
        },
      }}
    />
  );
};

export default LinearLoadingIndicator;
